export default "__VITE_ASSET__BWgmM918__"